<template>
    <form class="p-3" @submit.prevent="validar">
        <div class="row">
            <div class="form-group col-md-6 col-12">
                <label><i class="fa fa-asterisk text-danger"></i>Institución financiera</label>
                <combo-box
                        v-model="datos.institucion"
                        :opciones="lstIntituciones"
                        name="institución"
                        :valid="errors.has('institución')"
                        v-validate="{required:true,obj:true}"
                ></combo-box>
                <span class="form-text text-danger">{{errors.first("institución")}}</span>
            </div>
            <div class="form-group col-md-6 col-12">
                <label><i class="fa fa-asterisk text-danger"></i>Tipo de cuenta</label>
                <combo-box
                        v-model="datos.tipoCuenta"
                        :opciones="lstTipoCuenta"
                        name="tipo de Cuenta"
                        :valid="errors.has('tipo de Cuenta')"
                        v-validate="{required:true,obj:true}"
                ></combo-box>
                <span class="form-text text-danger">{{errors.first("tipo de Cuenta")}}</span>
            </div>
            <div class="form-group col-md-6 col-12">
                <label for="númerodc">N° de cuenta</label>
                <input
                        type="text"
                        class="form-control"
                        :class="errors.has('número de cuenta') && 'is-invalid'"
                        v-model="datos.numeroCuenta"
                        name="número de cuenta"
                        id="númerodc"
                        v-validate="{alpha_dash:true}"
                >
                <span class="form-text text-danger">{{errors.first("número de cuenta")}}</span>
            </div>
            <div class="col-12 col-md-12 p-1">
                <div class="col-12 col-md-4 p-1">
                    <button type="submit" class="btn btn-success btn-elevate btn-pill btn-block">Agregar</button>
                </div>
            </div>
        </div>
        <div class="table-responsive pt-2">
            <table class="table table-sm table-striped">
                <thead>
                <tr>
                    <th>Institución financiera</th>
                    <th>Tipo de cuenta</th>
                    <th>N° de cuenta</th>
                    <th class="text-center">Acción</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(i,ii) in registros" :key="ii" class="animated fadeInDown">
                    <th>{{i.dt2}}</th>
                    <td>{{i.dt4}}</td>
                    <td>{{i.dt1}}</td>
                    <td class="text-center">
                        <button type="button" class="btn btn-link btn-sm" v-on:click="eliminar(ii)" title="Eliminar">
                            <i class="fa fa-trash"></i>
                        </button>
                    </td>
                </tr>
                <tr v-if="!registros.length">
                    <td colspan="4" class="text-center text-muted">
                        No hay elementos agregados<br>
                        <span class="text-danger">Agregue elementos con el botón <code>Agregar</code></span>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </form>
</template>
<script>
    import comboBox from "../comboBox";
    export default {
        name: "referenciasBancarias",
        props: {
            sync:{
                type: Boolean,
                default:false,
            },
            previos:{
                type: Array,
                default: ()=>[],
            },
            lstIntituciones: {
                type: Array,
                required: true
            },
            lstTipoCuenta: {
                type: Array,
                required: true
            }
        },
        components: {
                comboBox
        },
        data: () => ({
            datos: {
                institucion: {id: null},
                tipoCuenta: {id: null},
                numeroCuenta: null
            },
            etiquetas: [
                "Institución financiera",
                "Tipo de cuenta",
                "N° de cuenta",
                "Acción"
            ],
            registros: [],
            cambio: true

        }),
        methods: {
            validar: function () {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        const datos = {
                            dt1: this.datos.numeroCuenta,
                            dt2: this.datos.institucion.dt1,
                            dt4: this.datos.tipoCuenta.dt1,
                            ndt1: this.datos.institucion.id,
                            ndt2: this.datos.tipoCuenta.id,
                        };
                        this.datos = {
                            institucion: {id: null},
                            tipoCuenta: {id: null},
                            numeroCuenta: null
                        };
                        this.registros.splice(0, 0, datos);
                    } else {
                        this.$toast.show(`Completa el formulario referencias bancarias`);
                    }
                });
            },
            eliminar(indice) {
                this.registros.splice(indice, 1);
            },
        },
        watch:{
            sync:function(){
                this.previos.forEach(
                    (e)=>{
                        this.registros.push(e)
                    }
                )
            },
            registros:function(val){
                this.$emit('input',val);
            }
        }
    }
</script>
<style scoped>

</style>
